import { StateCreator } from "zustand";
import { InformDialogProps } from "@mirage/components/informDialog/InformDialog";

export type InformDialogManagerState = {
    [key: string]: InformDialogProps;
};

export interface InformDialogSlice {
    informDialog: InformDialogManagerState;
    setInformDialog: (state: InformDialogManagerState) => void;
    updateInformDialogByKey: (key: string, props: Partial<InformDialogProps>) => void;
    resetInformDialog: () => void;
}

const initialInformDialogState: InformDialogManagerState = {};

export const createInformDialogSlice: StateCreator<InformDialogSlice, [], [], InformDialogSlice> = (set) => ({
    informDialog: initialInformDialogState,

    setInformDialog: (state) => set({ informDialog: state }),
    updateInformDialogByKey: (key, props) => set((state) => ({ informDialog: { ...state.informDialog, [key]: { ...state.informDialog[key], ...props } } })),
    resetInformDialog: () => set({ informDialog: initialInformDialogState }),
});
